/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ProposalDecision,
  ProposalOutcome
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Discard a proposed CRM change. Writes nothing to the CRM.
 * @summary Cancel Proposal
 */
export const soteriaCancelProposal = (
    proposalId: string,
    proposalDecision: ProposalDecision,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<ProposalOutcome>(
      {url: `/soteria/proposals/${proposalId}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: proposalDecision, signal
    },
      options);
    }




export const getSoteriaCancelProposalMutationKey = () => ['soteriaCancelProposal'] as const;

export const getSoteriaCancelProposalMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soteriaCancelProposal>>, TError,SoteriaCancelProposalMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof soteriaCancelProposal>>, TError,SoteriaCancelProposalMutationVariables, TContext> => {

const mutationKey = getSoteriaCancelProposalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soteriaCancelProposal>>, SoteriaCancelProposalMutationVariables> = (props) => {
          const {proposalId,data} = props ?? {};

          return  soteriaCancelProposal(proposalId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SoteriaCancelProposalMutationResult = NonNullable<Awaited<ReturnType<typeof soteriaCancelProposal>>>
    export type SoteriaCancelProposalMutationBody = ProposalDecision
    export type SoteriaCancelProposalMutationError = HTTPValidationError
    export type SoteriaCancelProposalMutationVariables = {proposalId: string;data: ProposalDecision}

    /**
 * @summary Cancel Proposal
 */
export const useSoteriaCancelProposal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soteriaCancelProposal>>, TError,SoteriaCancelProposalMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof soteriaCancelProposal>>,
        TError,
        SoteriaCancelProposalMutationVariables,
        TContext
      > => {
      return useMutation(getSoteriaCancelProposalMutationOptions(options));
    }
